import enviro from 'enviro';
export const debug = (...msgs) => {
  const debugMode = enviro.debug('navigation-components');
  const isDebugMode = debugMode === 'true' || debugMode === true;
  if (isDebugMode) {
    console.log('[navigation-components]', ...msgs);
  }
};